<div class="card card-custom gutter-b">
    <div class="card-header">
        <div class="card-title">
            <h1 class="card-label m-0">
                <ng-container *ngIf="project">{{ id ? "Edit" : "New" }} project</ng-container>
            </h1>
        </div>
        <div class="card-toolbar">
            <button type="button" class="btn-back"
               routerLink="/projects/list">
                <span class="fa fa-arrow-left"></span>
            </button>
        </div>
    </div>
    <div class="card-body">
        <app-form-message *ngIf="formSent" [success]="formResponse" [customErrorMessage]="errorMsg"
                          [customSuccessMessage]="successMsg"></app-form-message>

        <div class="mt-5" *ngIf="formLoaded">
            <form class="form" [formGroup]="formGroup" (ngSubmit)="save()">

                <div class="row">

                    <!--Left Side-->
                    <div class="col-12 col-sm-6">
                        <div class="row">
                            <!--Name-->
                            <div class="col-12 mb-6">
                                <label for="projectName" translate="PROJECTS.NAME"></label>

                                <input type="text"
                                       [class.is-invalid]="isControlInvalid('projectName')"
                                       id="projectName"
                                       class="form-control form-control-lg form-layout"
                                       name="projectName"
                                       formControlName="projectName"
                                       required
                                >
                                <div class="invalid-feedback"
                                     *ngIf="controlHasError('required', 'projectName')">
                                    This field is required!
                                </div>
                            </div>

                            <!--Budget-->
                            <div class="col-12 mb-6">
                                <label for="budget" translate="PROJECTS.BUDGET"></label>
                                <div class="input-group">
                                    <input type="number"
                                           id="budget"
                                           class="form-control form-control-lg form-layout"
                                           name="budget"
                                           formControlName="budget"
                                           [class.is-invalid]="isControlInvalid('budget')"
                                    >
                                    <div class="input-group-append">
                                        <span class="input-group-text form-layout form-append ">euro (€)</span>
                                    </div>
                                    <div class="invalid-feedback" *ngIf="controlHasError('min', 'budget')">
                                        The budget must be greater than 0
                                    </div>
                                </div>
                            </div>

                            <!--Start Date-->
                            <div class="col-12 col-sm-6 mb-6">
                                <label for="startDate" translate="PROJECTS.START_DATE"></label>

                                <input class="form-control form-control-lg form-layout"
                                       [class.is-invalid]="isControlInvalid('startDate')"
                                       id="startDate"
                                       type="date"
                                       required
                                       name="startDate"
                                       formControlName="startDate"
                                >
                                <div class="invalid-feedback" *ngIf="controlHasError('startDateIsBiggerThanEndDate', 'startDate')">
                                    Start Date can't be bigger than End Date
                                </div>
                                <div class="invalid-feedback" *ngIf="controlHasError('isEmpty', 'startDate')">
                                    This field is required
                                </div>

                            </div>

                            <!--Deadline-->
                            <div class="col-12 col-sm-6 mb-6">
                                <label for="deadline" translate="PROJECTS.DEADLINE"></label>

                                <input class="form-control form-control-lg form-layout"
                                       [class.is-invalid]="isControlInvalid('deadline')"
                                       id="deadline"
                                       type="date"
                                       required
                                       name="deadline"
                                       formControlName="deadline"
                                >
                                <div class="invalid-feedback" *ngIf="controlHasError('required', 'deadline')">
                                    This field is required!
                                </div>


                            </div>
                        </div>
                    </div>

                    <!--Description-->
                    <div class="col-12 col-sm-6 mb-6 project-description">
                        <label for="description" translate="PROJECTS.DESCRIPTION"></label>
                        <textarea name="description"
                                  id="description"
                                  cols="30"
                                  rows="5"
                                  formControlName="description"
                                  class="form-control form-control-lg form-layout blue-scroll-bar">
                        </textarea>
                    </div>

                    <hr>

                    <!--Nu sterge, o sa le folosim-->
                    <!--Contracts-->
<!--                    <div class="col-12 mb-6">
                        <label for="contract" translate="PROJECTS.CONTRACTS"></label>
                        <ng-select2 [options]="multipleOption" [data]="contractsArray" id="contract"
                                    formControlName="contract" *ngIf="loadContracts"></ng-select2>
                    </div>-->
                    <!--Fiscal Bills-->
<!--                    <div class="col-12 mb-6">
                        <label for="fiscalBill" translate="PROJECTS.FISCAL_BILL"></label>
                        <ng-select2 [options]="multipleOption" [data]="fiscalBillsArray" id="fiscalBill"
                                    formControlName="fiscalBill" placeholder="Numere facturi">

                        </ng-select2>
                    </div>-->

                    <!--Client ID-->
                    <div class="col-12 col-sm-6 mb-6">
                        <label for="clientId" translate="PROJECTS.CLIENT_ID"></label>
                        <select name="clientId"
                                class="form-control form-control-lg form-layout"
                                id="clientId"
                                formControlName="clientId"
                                (ngModelChange)="selectedClient($event)"
                        >
                            <option value="">None</option>
                            <option *ngFor="let client of clientsArray"
                                    value="{{client.id}}">{{client.firstName + ' ' + client.lastName}}</option>
                        </select>

                    </div>

                    <!--Client Name-->
                    <div class="col-12 col-sm-6 mb-6">
                        <label for="clientName" translate="PROJECTS.CLIENT_NAME"></label>
                        <input type="text" class="form-control form-control-lg form-layout"
                                id="clientName" formControlName="clientName">

                    </div>
                    <!--Client Email-->
                    <div class="col-12 col-sm-6 mb-6">
                        <label for="clientEmail" translate="PROJECTS.CLIENT_EMAIL"></label>
                        <input type="email" class="form-control form-control-lg form-layout"
                               id="clientEmail" formControlName="clientEmail"
                               [class.is-invalid]="isControlInvalid('clientEmail')">
                        <div class="invalid-feedback" *ngIf="controlHasError('email', 'clientEmail')">
                            This email is not valid!
                        </div>
                    </div>

                    <!--New Intl Phone Number-->
<!--                    <div class="col-12 col-sm-6 mb-6">-->
<!--                        <label for="clientPhone" translate="PROJECTS.CLIENT_PHONE"></label>-->
<!--                        <ngx-intl-tel-input [cssClass]="'intl-number'" [preferredCountries]="preferredCountries"-->
<!--                                            [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"-->
<!--                                            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [selectFirstCountry]="false"-->
<!--                                            [selectedCountryISO]="selectedCountry" [maxLength]="'15'"-->
<!--                                            [phoneValidation]="true" [separateDialCode]="separateDialCode"-->
<!--                                            [numberFormat]="PhoneNumberFormat.National" id="clientPhone" formControlName="clientPhone"-->
<!--                                            [class.is-invalid]="isControlInvalid('clientPhone')">-->
<!--                        </ngx-intl-tel-input>-->
<!--                        <div class="invalid-feedback" *ngIf="formGroup.controls['clientPhone'].errors?.validatePhoneNumber?.valid === false">-->
<!--                            This phone number is not valid!-->
<!--                        </div>-->
<!--                    </div>-->

                    <!--Nu sterge, probabil o sa-l folosim??-->
                    <!--Company Responsible-->
<!--                    <div class="col-12 mb-6">
                        <label for="responsibleUserId" translate="PROJECTS.COMPANY_RESPONSIBLE"></label>
                        <ng-select2 *ngIf="companyResponsibleLoaded" [data]="companyResponsibleArray"
                                    [options]="singleOption"
                                    id="responsibleUserId" formControlName="responsibleUserId">
                        </ng-select2>
                    </div>-->

                    <!--Products List-->
                    <div class="col-12 mb-6">
                        <label for="productList" translate="PROJECTS.PRODUCTS_LIST"></label>
                        <ng-select2 *ngIf="productsLoaded" [data]="productsArray"
                                    [options]="multipleOption"
                                    class="select-products"
                                    id="productList" formControlName="productList">
                        </ng-select2>
                    </div>

                    <div class="col-12 d-flex justify-content-end">
                        <button type="submit" class="btn-default btn-green">
                            <span class="fa fa-save mr-3"></span>
                            Save Project
                        </button>
                    </div>
                </div>

            </form>
        </div>
    </div>
</div>
